import {routesAfterLogin} from '../../../routes/router';
import NavMenu from '../NavMenu';
import Dropdown from "../../Dropdown";

const LoggedAppBar = () => {
    const routes = routesAfterLogin();
    return (
        //Nav Menu for logged users
        <NavMenu routes={routes}>
            <Dropdown/>
        </NavMenu>
    )
}
export default LoggedAppBar;
